import request from "@/api/request";

export default {
  getMenuPEAuthItemsByLoggedUser(param) {
    return request({
      url: '/authItems/getMenuPEAuthItemsByLoggedUser',
      method: 'get',
    })
  },
  getAllMenu(){
    return request({
      url: '/authItems/authItemsList',
      method: 'post',
    })
  },
  getInfoCodeAuthItemsList(param){
    return request({
      url: '/authItems/getInfoCodeAuthItemsList',
      method: 'post',
      data: param
    })
  },
  save(param) {
    return request({
      url: '/authItems/save',
      method: 'post',
      data: JSON.stringify(param)
    })
  },
  del(id) {
    return request({
      url: `/authItems/deleteByIds?ids=${id}`,
      method: 'delete',
    })
  },
  getMenuByRole(roleId){
    return request({
      url: '/role/getRoleAuthItemsIds?roleId='+roleId,
      method: 'post',
    })
  },
  getInfoCodeByRole(roleId){
    return request({
      url: '/role/getRoleInfoCodeAuthItemsIds?roleId='+roleId,
      method: 'post',
    })
  },
  getInfoCodeByUserRole(userId){
    return request({
      url: '/role/getUserInfoCodeAuthItemsIds?userId='+userId,
      method: 'post',
    })
  },
  setRoleMenu(param){
    return request({
      url: '/role/setAuthItems',
      method: 'post',
      data: param
    })
  },
  setInfoCodeAuthItems(param){
    return request({
      url: '/role/setInfoCodeAuthItems',
      method: 'post',
      data: param
    })
  },
  weakPasswordCheck(param){
    return request({
      url: '/authItems/weakPasswordCheck',
      method: 'post',
      data: {password: param}
    })
  },
}
